import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import ComponentBackButton from "../../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import GrayHeading from "../../../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"

const AddNewFeeForm = ({ onClick }) => {
  return (
    <div className="bg-white p-3 mt-3 shadow">
      <ComponentBackButton onClick={() => onClick((prev) => !prev)} />
      <div className="d-flex justify-content-center">
        <GrayHeading>Add New Fee</GrayHeading>
      </div>

      <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="categoryName">
                Category Name
              </Label>
              <Input id="categoryName" name="categoryName" placeholder="Name" type="text" />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="rateAmount">
                Rate/Amount
              </Label>
              <Input id="rateAmount" name="rateAmount" placeholder="" type="text" />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="applicability">
                Applicability
              </Label>
              <Input id="applicability" name="applicability" placeholder="" type="text" />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="effectiveDate">
                Effective Date
              </Label>
              <Input id="effectiveDate" name="effectiveDate" placeholder="" type="date" />
            </FormGroup>
          </Col>
        </Row>

        <div className="d-flex justify-content-center my-3 gap-3">
          <DynamicButton theme="blue-outline">Cancel</DynamicButton>
          <DynamicButton theme="blue">Add Fee</DynamicButton>
        </div>
      </Form>
    </div>
  )
}

export default AddNewFeeForm
